(function(){
  window.vvReady = true;
  function init(root){
    var els = (root || document).querySelectorAll('.vv-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){ e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function(e){ if (e.dataset.vvDelay) { e.style.transitionDelay = e.dataset.vvDelay + 'ms'; } io.observe(e); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function(ev){ init(ev.target); ev.target.querySelectorAll('.vv-reveal').forEach(function(e){ e.classList.add('is-visible'); }); });
})();
